// extracted by mini-css-extract-plugin
export default {"login":"login_login__jYuYf","form":"login_form__2L96z","links":"login_links__jIkQ3"};